import { render, staticRenderFns } from "./SingleSpecs.vue?vue&type=template&id=26ca8f6c&scoped=true"
import script from "./SingleSpecs.vue?vue&type=script&lang=js"
export * from "./SingleSpecs.vue?vue&type=script&lang=js"
import "./SingleSpecs.vue?vue&type=style&index=0&id=26ca8f6c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ca8f6c",
  null
  
)

export default component.exports